import { Receipt } from "lucide-react";
import { fmtMoney } from "../../lib/format";

function Row({ label, value, testId }) {
  return (
    <div className="flex justify-between text-sm py-1.5">
      <span className="text-slate-300">{label}</span>
      <span className="font-mono" data-testid={testId}>{value}</span>
    </div>
  );
}

export function QuoteSummary({ calc, submitting, requestType, itemCount }) {
  const cur = calc?.currency || "CAD";
  return (
    <div className="lg:sticky lg:top-28 bg-[#0F172A] text-white rounded-sm p-6 sm:p-8" data-testid="quote-summary">
      <div className="flex items-center gap-2 text-[#FFD700] mb-1">
        <Receipt className="h-4 w-4" />
        <span className="text-xs font-semibold uppercase tracking-wider">Price Summary</span>
      </div>
      <div className="text-sm text-slate-300 mb-5" data-testid="quote-summary-route">
        {calc ? `${calc.origin} → ${calc.destination}` : "Select a route to start"}
      </div>
      <div className="border-t border-white/10 pt-3">
        {calc?.lines?.map((l, i) => (
          <Row key={`${l.type}-${i}`} label={`${l.qty} × ${l.label}`} value={fmtMoney(l.total, cur)} />
        ))}
        {itemCount === 0 && <p className="text-sm text-slate-400 py-1.5">No items yet</p>}
      </div>
      <div className="border-t border-white/10 mt-3 pt-3">
        <Row label="Items subtotal" value={fmtMoney(calc?.subtotal, cur)} testId="quote-subtotal" />
        <Row label={calc?.method === "pickup" ? "Pickup fee" : "Drop-off"} value={calc?.method === "pickup" ? fmtMoney(calc.pickup_fee, cur) : "Free"} testId="quote-pickup-fee" />
        {calc?.liftgate_fee > 0 && <Row label="Lift-gate truck" value={fmtMoney(calc.liftgate_fee, cur)} testId="quote-liftgate-fee" />}
      </div>
      <div className="border-t border-white/10 mt-3 pt-4">
        <div className="text-xs uppercase tracking-wider text-slate-400">Estimated total</div>
        <div className="text-4xl font-display font-extrabold text-[#FFD700] mt-1" data-testid="quote-total">{fmtMoney(calc?.total, cur)}</div>
        {calc && <div className="text-xs text-slate-400 mt-1" data-testid="quote-alt-total">≈ {fmtMoney(calc.alt_total, calc.alt_currency)} {calc.alt_currency}</div>}
      </div>
      <button type="submit" disabled={submitting || !calc || itemCount === 0} className="mt-6 w-full px-6 py-3 bg-[#FFD700] text-[#1E2A78] font-semibold rounded-sm hover:bg-[#E6C200] disabled:opacity-50 transition-colors" data-testid="quote-submit-btn">
        {submitting ? "Sending..." : requestType === "booking" ? "Submit Booking Request" : "Save My Quote"}
      </button>
      <p className="mt-4 text-[11px] leading-relaxed text-slate-400">
        Estimates only. Final price is confirmed when items are received and measured. Customs duties and GCT at destination are paid by the receiver.
      </p>
    </div>
  );
}
